import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useStyles } from './styles';

interface IDialogProps {
  dialogTitle: string;
  children: React.ReactNode;
  isOpenDialog: boolean;
  handleCloseDialog: () => void;
  dialogActionButton1: React.ReactNode;
  dialogActionButton2: React.ReactNode;
}

export default function CustomizedDialogs({
  dialogTitle,
  children,
  isOpenDialog,
  handleCloseDialog,
  dialogActionButton1,
  dialogActionButton2
}: IDialogProps) {
  const { classes } = useStyles();

  return (
    <div>
      <Dialog onClose={() => { }} aria-labelledby="customized-dialog-title" open={isOpenDialog}>
        <DialogTitle id="customized-dialog-title">
          {dialogTitle}
          <IconButton aria-label="close" className={classes.closeButton} onClick={handleCloseDialog}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>{children}</DialogContent>

        <DialogActions>
          {dialogActionButton1}
          {dialogActionButton2}
        </DialogActions>
      </Dialog>
    </div>
  );
}
